import { INQUIRY_ITEM } from '@/types'
import { isPast } from 'date-fns'

export const highlightInquiry = (
  props: INQUIRY_ITEM,
  inquiriesStore: ReturnType<typeof useInquiriesStore>,
) => {
  const handleShowRespond = () => {
    if (isPast(inquiriesStore.getInquiryEndTime(props))) {
      return false
    }

    return (
      (props.last_comment?.author_role === 'consumer' &&
        props.last_unread_consumer_comment_id) ||
      props.status === 'waiting on you'
    )
  }

  const handleShowFollowUp = () => {
    if (isPast(inquiriesStore.getInquiryEndTime(props))) {
      return false
    }

    return (
      props.last_comment?.author_role === 'customer' &&
      inquiriesStore.isLastCommentPast24hrs(props) &&
      (props.status === 'waiting on customer' ||
        props.status === 'autoresponse sent')
    )
  }

  return {
    showRespond: handleShowRespond() as boolean,
    showFollowUp: handleShowFollowUp() as boolean,
  }
}
